import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="bg-cobra-black min-h-screen">
      {/* Hero */}
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/4162451/pexels-photo-4162451.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          }}
        />
        <div className="absolute inset-0 bg-cobra-black/85" />
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-4"
        >
          <Shield className="text-cobra-red mx-auto mb-4" size={48} />
          <h1 className="font-anton text-5xl md:text-7xl text-white uppercase tracking-wider">
            PRIVACY <span className="text-cobra-red">POLICY</span>
          </h1>
        </motion.div>
      </section>

      {/* Content */}
      <section className="py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-cobra-dark/30 border border-white/10 rounded-sm p-8 md:p-12 space-y-8 font-manrope text-white/70 leading-relaxed"
          >
            <p>
              At Cobra Thai, we are committed to protecting your privacy. This privacy policy explains how we collect, use, and share information about you when you visit our website or purchase a membership with us.
            </p>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">1. Information We Collect</h2>
              <p>
                We may collect personal information from you, such as your name, email address, phone number, and payment information, when you create an account, make a purchase, or sign up for our newsletter. We may also collect information about your location, device, and browsing activity when you use our website.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">2. How We Use Your Information</h2>
              <p>
                We use the information we collect to provide and improve our services, including processing orders and payments, sending marketing communications, and analyzing website usage. We may also use your information to respond to inquiries, resolve disputes, and enforce our policies.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">3. Sharing of Information</h2>
              <p>
                We may share your information with third parties in order to provide and improve our services, such as payment processors, email service providers, and marketing partners. We may also share your information in response to legal requests or to protect the rights, property, or safety of Cobra Thai, our users, or the public.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">4. Cookies</h2>
              <p>
                We use cookies and similar technologies to collect and store information about your browsing activity and device. You can disable cookies in your browser settings, but this may affect your ability to use certain features of our website.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">5. Data Security</h2>
              <p>
                We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no online system is completely secure, and we cannot guarantee the security of your information.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">6. Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. Any changes will be effective immediately upon posting to this website. We encourage you to review this policy periodically to stay informed about our privacy practices.
              </p>
            </div>

            <div className="border-t border-white/10 pt-8 mt-8">
              <p>
                If you have any questions or concerns about our privacy policy, please contact us at{' '}
                <a href="mailto:info@cobrathai.com" className="text-cobra-red hover:underline">
                  info@cobrathai.com
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;